import utils from 'utils';

import {useState} from 'react';

import {UiDatePicker, UiChip, UiProgress} from '@components/export';
import {useLabel} from '@/hooks/export';

export const SidePanelControls = (props: {
    mode: 'product' | 'order',
    loading: boolean,
    currentDate: Date,
    searchQuery: string,
    itemList: apiOrder[] | apiProduct[],
    flags: {[name: string]: boolean}

    onDateChange: (date: Date) => void,
    onHideDone: (checked: boolean) => void,
    onShowPrevious: (checked: boolean) => void,
    onSearch: (query: string) => void,
}) => {
    const [showSearch, setShowSearch] = useState(false);

    const data = {
        options: [
            {name: 'hideDone', label: 'Pouze nenabroušené', checked: props.flags.hideDone},
            {name: 'showPrevious', label: 'Předchozi', checked: props.flags.showPrevious},
        ],
    };

    const label = useLabel();

    const handle = {
        modifyDate(days: number) {
            if (!props.loading) {
                const newDate = new Date(props.currentDate);

                if (days > 0 && newDate.getDay() === 5) {
                    days = 3;
                } else if (days < 0 && newDate.getDay() === 1) {
                    days = -3;
                }

                newDate.setDate(newDate.getDate() + days);
                props.onDateChange(newDate);
            }
        },
    };

    const computed = {
        qtyDone: props.itemList.reduce((acc, item) => acc += item.qtyDone, 0),
        qtyToDo: props.itemList.reduce((acc, item) => acc += item.qtyToDo, 0),
    };

    return <div className={cmpClass}>
        <div className={classMap.dateSelector}>
            <div
                className={
                    classMap.dateBtn + ' ' +
                    classMap.dateBtnForward + ' iconfa-arrowLeft' +
                    (props.loading ? ' ' + classMap.dateBtnLoading : '')
                }
                onClick={() => handle.modifyDate(-1)}
            ></div>
            <div className={classMap.dateCurrent}>
                <UiDatePicker
                    value={props.currentDate}
                    label={''}
                    onChange={(date) => props.onDateChange(date.toDate())}/>
            </div>
            <div
                className={
                    classMap.dateBtn + ' ' +
                    classMap.dateBtnBackward + ' iconfa-arrowRight' +
                    (props.loading ? ' ' + classMap.dateBtnLoading : '')
                }
                onClick={() => handle.modifyDate(1)}
            ></div>
        </div>
        <div className={classMap.chip}>
            <UiChip
                options={props.mode === 'order' ? data.options : [data.options[0]]}
                onClick={
                    (name: string, value: boolean) => {
                        if (props.loading) {
                            return;
                        }

                        switch (data.options.findIndex((option: uiChipOption) => name === option.name)) {
                            case 0:
                                props.onHideDone(value);
                                break;
                            case 1:
                                props.onShowPrevious(value);
                                break;
                        }
                    }
                }
                disabled={props.loading}
            />
        </div>
        <div className={classMap.progress}>
            {
                !showSearch ?
                    <>
                        <div className={classMap.progressWrapper}>
                            <div className={classMap.progressLabel}>
                                {label.toDoTotal}
                                <b>
                                    {(!props.loading ? `:  ${computed.qtyDone} / ${computed.qtyToDo}` : ': - / -')}
                                </b>
                                {' ks'}
                            </div>
                            <UiProgress
                                value={!props.loading && computed.qtyToDo ? (computed.qtyDone / computed.qtyToDo) * 100 : 0}
                            />
                        </div>
                        <i
                            className={'iconfa-search' + ' ' + classMap.searchIcon}
                            onClick={() => {
                                props.onSearch('');
                                setShowSearch(true);
                            }}
                        />
                    </> :
                    <div className={classMap.searchWrapper}>

                        <input
                            type="text"
                            onChange={(e) => props.onSearch(e.target.value)}
                            value={props.searchQuery}
                            autoFocus
                        />
                        <b>
                            {(!props.loading ? `${computed.qtyDone} / ${computed.qtyToDo}` : '- / -')}
                        </b>
                        <i
                            className={
                                classMap.searchIcon + ' ' +
                                classMap.searchIconActive + ' ' +
                                (props.searchQuery ? 'iconfa-close' : 'iconfa-search')
                            }
                            onClick={() => {
                                props.onSearch('');

                                if (!props.searchQuery) {
                                    setShowSearch(false);
                                }
                            }}
                        />
                    </div>
            }
        </div>
    </div>;
};

const cmpClass = 'side-panel-controls';
const classMap = utils.generateClassMap(cmpClass, {
    chip: 'chip',
    controls: 'controls',
    dateBtn: 'date-btn',
    dateBtnBackward: 'date-btn--backward',
    dateBtnForward: 'date-btn--forward',
    dateBtnLoading: 'date-btn--loading',
    dateCurrent: 'date-current',
    dateSelector: 'date-selector',
    progress: 'progress',
    progressLabel: 'progress-label',
    progressWrapper: 'progress-wrapper',
    searchWrapper: 'search-wrapper',
    searchIcon: 'search-icon',
    searchIconActive: 'search-icon--active',
});
